import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { Sun, Moon } from 'lucide-react';

export default function ColorModeIconDropdown() {
  const { mode, setMode } = useColorScheme();
  if (!mode) {
    return null;
  }
  return (
    <IconButton
      data-screenshot="toggle-mode"
      onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}
      disableRipple
      size="small"
    >
      {mode === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    </IconButton>
  );
}
